import { styled } from '@mui/system'
import MuiMenuItem from '@mui/material/MenuItem'
import Typography from '../../../atoms/typography'

const Root = styled('div')`
	max-width: 140px;
	.MuiFormControl-root {
		& > .MuiFormHelperText-root {
			display: none;
		}

		.MuiInputBase-root {
			> .MuiSelect-select {
				&.MuiInputBase-input.MuiOutlinedInput-input {
					padding-right: 50px;
				}
			}
			&:not(.selected) {
				.MuiSelect-select {
					color: ${({ theme }) => theme.palette.primary.main};
				}

				.MuiOutlinedInput-notchedOutline {
					border-color: ${({ theme }) => theme.palette.grey.light};
				}
			}
			&.selected {
				.MuiSelect-select {
					color: ${({ theme }) => theme.palette.primary.main};
				}

				.MuiOutlinedInput-notchedOutline {
					border-color: ${({ theme }) => theme.palette.primary.main};
				}
			}
		}
	}
`

const MenuItem = styled(MuiMenuItem)`
	&.Mui-disabled {
		display: block;
		opacity: 1;
		color: ${({ theme }) => theme.palette.grey.light};
	}
`

const TitleAccordion = styled(Typography)`
	span {
		text-transform: capitalize;
	}
`

export { Root, MenuItem, TitleAccordion }
